import { userModalRoute } from './router';

function testIsValidUserModalRoute(routeName) {
    return Object.values(userModalRoute).includes(routeName);
}

export { testIsValidUserModalRoute };
